import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  <path fill="currentColor" d="M3.975 15.75h8.05v-1.5h-8.05zm0-4.25h8.05V10h-8.05zM1.5 20q-.6 0-1.05-.45T0 18.5v-17Q0 .9.45.45T1.5 0h9.025L16 5.475V18.5q0 .6-.45 1.05T14.5 20zM9.775 6.15V1.5H1.5v17h13V6.15zM1.5 1.5v4.65zv17z" />
, 'DisplayDocOutlinedx');
